// WhatsApp normalizado — ESPELHO de public.telefone_whatsapp_br() no banco. É por este
// número que o programa reconhece a mesma pessoa (as negociações têm o WhatsApp gravado
// de vários jeitos). Mudou lá, muda aqui.

const DDDS = new Set([
  '11', '12', '13', '14', '15', '16', '17', '18', '19', '21', '22', '24', '27', '28',
  '31', '32', '33', '34', '35', '37', '38', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '51', '53', '54', '55', '61', '62', '63', '64', '65', '66', '67', '68', '69',
  '71', '73', '74', '75', '77', '79', '81', '82', '83', '84', '85', '86', '87', '88', '89',
  '91', '92', '93', '94', '95', '96', '97', '98', '99',
]);

/** "(62) 9468-7599" → "5562994687599". Número inválido → null. */
export function normalizarWhatsapp(valor: string | null | undefined): string | null {
  let dig = String(valor ?? '').replace(/\D/g, '');
  // '0 62 9468-7599': o 0 de discagem antes do DDD.
  if (dig.startsWith('0') && (dig.length === 11 || dig.length === 12)) dig = dig.slice(1);
  // 10–11 dígitos é nacional: ganha o 55.
  let com = dig.length === 10 || dig.length === 11 ? `55${dig}` : dig;
  // Celular antigo, sem o nono dígito: 55 + DDD + 8 dígitos começando em 6–9.
  if (com.startsWith('55') && com.length === 12 && /[6-9]/.test(com[4])) {
    com = `55${com.slice(2, 4)}9${com.slice(4)}`;
  }
  if (!/^55\d{10,11}$/.test(com)) return null;
  if (!DDDS.has(com.slice(2, 4))) return null;
  if (/^(\d)\1+$/.test(com.slice(4))) return null;
  return com;
}
